/**
 * Libs (rendo disponibili globalmente)
 */
import Utilities from "./lib/Utilities";
import Form from "./lib/Form";
window.Form = Form;
window.Utilities = Utilities;

var debugMode = window.ENV == 'local';

/**
 * DOM ready
 */
$(function() {

});


/**
 * Load
 */
$(window).on("load", function() {

    
    /**
     * Init di barba
     * Deve essere incluso nella blade base!
     * L'evento "loadermanager-page_loaded" viene lanciato quando la coda
     * di LoaderManager è stata svuotata
     */
    $(document).on("loadermanager-page_loaded", function() {

        // init barba.js
        barbaInit();

        //inizializzo lenis scroll
        lenisInit();
        
        //inizializzo il menu
        menuInit();


        setTimeout(function() {
            pageEnter();
            $('body').removeClass('loading');
        }, 200);

    });


    /**
     * Configurazione globale componenti uikit
     */
    (function() {
        // container false per modal, evita duplicazione elemento in seguito a caricamenti asincroni (barba.js)
        UIkit.mixin({
            data: {
                container: false,
            }
        }, 'modal');
    })();


    /**
     * Update necessari dopo caricamenti livewire
    */
    Livewire.hook('message.processed', function () {
       
        // scroll a eventuale messaggio di errore form
        scrollToFormError();

    });


    // scroll a eventuale messaggio di errore form, al caricamento!
    scrollToFormError();
        
    
    /**
     * Fine caricamento
     */
    LoaderManager.eventComplete("site_loading");

    /**
     * Init di lazysizes
     */
    document.addEventListener('lazyloaded', function (e) {
        e.target.classList.remove('loading');
    });
    lazySizes.init();

});

function menuInit(){
    const els = document.querySelectorAll(".menuDropdown");
    const header = $("header");
    els.forEach((el) => {
        //click su voci di primo livello che hanno il sottomenu (about e prodotti)
        el.addEventListener('click', function(e) {
            e.preventDefault();
            var myClass= this.getAttribute('href').substring(1);
        
            if(header.hasClass(myClass)){
                header.removeClass(myClass);
                lenis.start();
                $('body').removeClass('fakeScroll');
            } else {
                header.removeClass("about products").addClass(myClass);
                lenis.stop();
                //per evitare spostamenti del menu (con o senza barra di scroll)
                $('body').addClass('fakeScroll');
            }
            
        });

    });

    //$("header > nav").width(document.documentElement.clientWidth-60);

}

function lenisInit(){
    
    const lenis = new Lenis({
        duration: 1.2,
        easing: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)),
        direction: "vertical",
        gestureDirection: "vertical",
        smooth: true,
        smoothTouch: false,
        touchMultiplier: 2,
    });
   

    
    // lenis.on('scroll', (e) => {
    //     console.log(e);
    // })
    

    function raf(time) {
        lenis.raf(time)
        requestAnimationFrame(raf)
    }

    requestAnimationFrame(raf)

    window.lenis = lenis;
}

/**
 * Scroll al primo messaggio di errore di un form
 */
function scrollToFormError()
{
    // se ho dei messaggi di validazione di un form, scrollo al primo messaggio
    if (!$('form .field__error').length) {
        return;
    }

}


/**
 * Funzione di uscita pagina
 */
function pageExit(callback) {   
    if(debugMode){console.log("-----page EXIT")}
    // porto in primo piano prima di iniziare animazione
    $("#page_loader").css({
        zIndex: 981 // sotto all'header!
    });
    
    

    
    //animazione in uscita dalla pagina (il loader entra)     
    $( "#page_loader" ).animate({top:0}, 500, function() {
        // Animation complete


        //se serve chiudi i sottomenu
        $('header').removeClass('visibile about products');
        lenis.start();
        $('body').removeClass('fakeScroll');

        if (callback && typeof(callback) == 'function') {
            callback();
        }
    });
   
   
}


/**
 * Funzione di entrata pagina
 */
function pageEnter(callback) {

    //animazione in entrata della pagina (uscita del loader)
    $( "#page_loader" ).animate({opacity: "0"}, 1000, function() {

        // Animation complete
        
        // porto sotto per poter interagire con pagina
        $("#page_loader").css({
            zIndex: -1,
            top:'100vh',
            opacity:1
        });
        if (callback && typeof(callback) == 'function') {
            callback();
        }
    })


    initSliderManifesto();
   

    UIkit.util.on('.uk-scrollspy', 'inview', function() {
        var objVideo = $(this).find('video.autoplay');
        if(objVideo.length > 0){
            objVideo[0].play();
        }
    });
}

function initSliderManifesto(){

    if($('.manifesto').length>0){
    
        var desk = ($(window).width() > 1270);
        var sliderHeight = 'auto';
        var animation = 'push'
        if($(window).width() > 1270){
            sliderHeight = 550;
        }
        UIkit.slideshow($('.sliderPrincipale'), {
            animation: 'push',
            minHeight: sliderHeight,
            autoplay: true,
        });

        if (desk) {
            var successivo = UIkit.slideshow($('.sliderSuccessivo'), {
                animation: 'fade',
                minHeight: 460,
                draggable: false,
            });
            var precedente = UIkit.slideshow($('.sliderPrecedente'), {
                animation: 'fade',
                minHeight: 460,
                draggable: false,
            });
            $('.manifesto .uk-slideshow-nav').remove();
        } else {
            //rimuovo i 2 slider aggiuntivi
            $('.sliderPrecedente').remove();
            $('.sliderSuccessivo').remove();
        }
        
        //al cambio slide
        $('.sliderPrincipale ul > li').on('itemshow', function(e){
            var slideAttiva = Number($(this).attr('data-num'));
            //cambio classe al div contenitore
            $('.manifesto').removeClass('s1 s2 s3').addClass('s'+ slideAttiva);

            //gestione degli altri 2 slider
            if (desk) {
                var numPrev = slideAttiva-1;
                if(numPrev<1){
                    numPrev = 3;
                }
                var numNext = slideAttiva+1;
                if(numNext>3){
                    numNext = 1;
                }
                
                //porto avanti anche il successivo e il precedente
                setTimeout(function() {
                    precedente.show(numPrev-1);
                }, 200);

                setTimeout(function() {
                    successivo.show(numNext-1);
                }, 250);
            }

            
        });
    }
}


/**
 * Gestione caricamento asincrono
 */
function barbaInit()
{
   
    // controllo disponibilità barba
    if(typeof(barba) === "undefined") {
        return console.log("barba non disponibile");
    }

    barba.init({
        debug: window.ENV === 'local',
        logLevel: window.ENV === 'local' ? 'debug' : 'error',
        cacheIgnore: true, // da usare in combinazione con window.livewire.rescan() dopo la transizione (v. sotto)
        transitions: [{
            name: 'default-transition',
            beforeLeave(data) {

                


                // attendi finchè loader entra prima di lasciare la pagina
                const done = this.async();
                
                // qui posso fare altre cose.....
                return pageExit(function() {
                    return done();
                });

            },
            leave(data) {
                //console.log("leave");
                lenis.scrollTo(0, {immediate:true});

                
                
            },
            afterLeave(data) {
                //console.log("afterLeave");
            },
            beforeEnter(data) {

                //console.log("beforeEnter");
            },
            enter(data) {
                //console.log("enter");
            },
            afterEnter(data) {

                // tracciamento analytics
                // if(typeof(gtag) == 'function' && typeof(GA_MEASUREMENT_ID) != 'undefined') {
                //     gtag('config', GA_MEASUREMENT_ID, {'page_path': window.location.pathname});
                // }
                
                updateDom(data, function() {
                    pageEnter();

                    // rebind degli eventi livewire sui nuovi contenuti caricati
                    if(window.livewire) {
                        window.livewire.rescan();
                    }

                });

            }
        }],
        views: [
            {
                namespace : 'homepage',
                afterEnter(data) {
                    //su mobile rimuovo il video, sostituisco con il testo del title dell'H1
                    if($(window).width() < 961){
                        setTimeout(function() {
                            $('h1 video').remove();
                            $('h1').text($('h1').attr('title'));
                        }, 50);
                    } 
                }
            },{
                namespace : 'rivenditori',
                afterEnter(data) {
                    
                    const modalObj = document.querySelectorAll('#modalMappa');
                    
                    const openModalButtons = document.querySelectorAll('a[href="#modalMappa"]');

                    openModalButtons.forEach(function(button) {
                        
                        button.addEventListener('click', function(e) {
                            e.preventDefault();
                            const myUrl = this.getAttribute('data-url');
                            $('#iframeModal').attr('src', myUrl);
                            UIkit.modal(modalObj).show();
                        });
                    });
                }
            }
        ],
        requestError: (trigger, action, url, response) => {
            
            // forzo a seguire le url 404 per visione del messaggio
            if(action == 'click' && response.status == 404) {
                window.location.href = url;
                return false;
            }

            console.log(trigger, action, url, response);

        },
        preventRunning : true
    });


}


/**
 * Aggiorna il dom.
 * Sono possibili diverse strategie (combinarle a bisogno):
 * 1. sostituire in toto l'head (questo scatena anche anche esecuzione degli script, anche inline)
 * 2. sostituire tag specifici nell'head
 * 3. - inserire script/style specifici per la nuova pagina nel container di quest'ultima.
 *    - caricare gli script in ajax, mentre eventuali tag <style> presenti nel container verranno automaticamente valutati dal browser
 * 
 * Con gli stessi sistemi si possono aggiornare elementi al di fuori del container di barba
 */
function updateDom(data, callback) {

    var html = data.next.html;
    var newHeadHtml = html.match( /<head[\s\S]*?>[\s\S]*?<\/head>/gi )[0];

    // true mantiente gli script
    var $newPageHead = $.parseHTML(newHeadHtml, document, true);


    /**
     * Aggiorno namespace di body 
     */
    $("body").attr("data-namespace", data.next.namespace);


    /**
     * Aggiorno elemento attivo menu principale
     */
    $("#page_header-mainmenu .uk-active").removeClass("uk-active");
    $('#page_header-mainmenu [data-namespace="'+data.next.namespace+'"]').addClass("uk-active");
    
    
    /**
     * aggiorno html altri elementi
     * In ogni elemento dell'array inserire:
     * - o il selettore completo
     * - o il selettore + l'attributo che si vuole rimpiazzare
     */
    [
        'head',
        '#page_header-mainmenu',
        ['#page_header .logo a', 'href'],
        '#page_footer .info_menu'
    ].forEach((selector) => {

        let realSelector = Array.isArray(selector) ? selector[0] : selector;
        let attribute = Array.isArray(selector) ? selector[1] : null;

        // recupero elemento nel nuovo html in arrivo
        let el = $(realSelector, $(data.next.html));

        // no lambda qui!
        $(realSelector).each(function() {
            if(attribute !== null) {
                // rimpiazzo attributo
                $(this).attr(attribute, el.attr(attribute));
            } else {
                // rimpiazzo contenuto html nella pagina
                $(this).html(el.html());
            }
        });

    });


    /**
     * 1. aggiornamento in toto dell'head
     */
    //$("head").html(newHeadHtml);

    
    /**
     * 2. aggiornamento di script specifici nell'head
     */
    $newPageHead = $( '<head />' ).html($newPageHead);
    var headTags = [
        "meta[name='keywords']",
        "meta[name='description']",
        "meta[property^='og']",
        "meta[name^='twitter']",
        "meta[itemprop]",
        "link[itemprop]",
        "link[rel='prev']",
        "link[rel='next']",
        "link[rel='canonical']",
        "link[rel='alternate']"
    ].join( ',' );
    
    $( 'head' ).find( headTags ).remove();
    
    $newPageHead.find( headTags ).appendTo( 'head' );
    /**
     * 2. // fine
     */


    /**
     * 3. Caricamento degli script presenti nel container della nuova pagina
     */
    $(data.next.container).find('script').each(function (i, script) {
        var $script = $(script);

        // script linkato
        if($script.attr('src')) {
            $.getScript($script.attr('src'));
        // script inline
        } else {
            $script.appendTo('[data-barba="container"]');
        }
        
    });
    /**
     * 3. // fine
     */

    if(callback && typeof(callback) == 'function') {
        return callback();
    }

    return true;
    
}

function checkMobile() {
    if ($(window).width() > 959) {
        return false;
    } else {
        return true;
    }
}

function checkTouch() {
    if ($('html').hasClass('touch')) {
        return true;
    } else {
        return false;
    }
}

//controllo se si è su IOS
function checkIos(){
    var
        is_ios = /iP(ad|od|hone)/i.test(window.navigator.userAgent)
        //,is_safari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
    if ( is_ios ) {
        return true;
    } 
}